import { useEffect, useState } from 'react';

import { getSimulateData } from '@services/renewal';

import { GalliumPriceArray } from '@app-types/renewal';
import { UserType } from '@app-types/user';

export function useFillGallium(
    setIsGalliumLoading: (isLoading: boolean) => void,
    isRenewal: boolean,
    contractId?: string,
    user?: UserType,
) {
    const [galliumData, setGalliumData] = useState<GalliumPriceArray | undefined>(undefined);

    useEffect(() => {
        if (isRenewal && contractId && user?.accessToken) {
            setIsGalliumLoading(true);
            getSimulateData(contractId, user).then((res) => {
                setGalliumData(res);
                setIsGalliumLoading(false);
            });
        }
    }, [isRenewal, contractId, user?.accessToken]);

    return galliumData;
}
